<script>
export default {
	props: {
		data: Object,
	},
	data() {
		return {
			isIntersecting: false,
		}
	},
	computed: {
		src() {
			const getYoutubeUrl = (id) =>
				`https://www.youtube.com/embed/${id}?controls=0&showinfo=0&rel=0&autoplay=1&mute=1&loop=1&playlist=${id}`
			const getVimeoUrl = (id) => `https://player.vimeo.com/video/${id}?background=1&muted=1&autoplay=1`

			if (this.isYoutube) return getYoutubeUrl(this.getVideoId)
			else return getVimeoUrl(this.getVideoId)
		},
		getVideoId() {
			if (this.isSelfHosted) return
			else if (this.isYoutube) return this.data.src.split('watch?v=').pop()
			else return this.data.src.split('/').pop()
		},
		isYoutube() {
			return this.data.host === 'youtube'
		},
		isSelfHosted() {
			return this.data.host === 'self' || this.data.host === 'mediaLibrary'
		},
		// cVideo() {
		// 	if (this.data?.video.location === 'youtube') {
		// 		return {
		// 			...this.data.video,
		// 			url:
		// 				this.data.video.url +
		// 				`?controls=0&showinfo=0&rel=0&autoplay=1&mute=1&loop=1&playlist=${this.data.video.data.videoId}`,
		// 		}
		// 	} else if (this.data?.video.location === 'vimeo') {
		// 		return {
		// 			...this.data.video,
		// 			url: this.data.video.url + '?background=1&muted=1&autoplay=1',
		// 		}
		// 	} else {
		// 		return this.data.video
		// 	}
		// },
	},
	methods: {
		onIntersect(entries) {
			this.isIntersecting = entries[0].isIntersecting
		},
	},
}
</script>

<template>
	<Container v-if="data.src || data.video" fluid v-intersect.once="onIntersect">
		<RatioBox width="100%" :aspectRatio="1264 / 609" style="position: relative" class="grey">
			<div class="video-container">
				<div class="video-container">
					<div
						class="background-overlay"
						:style="{
							'background-color': data.overlayColor || '#fff',
							opacity: data.overlayOpacity || 0,
						}"
					></div>

					<iframe
						v-if="!isSelfHosted"
						id="video-background"
						:src="src"
						frameborder="0"
						allow="autoplay; encrypted-media"
						allowfullscreen
					>
					</iframe>

					<Media
						v-else
						id="video-background"
						style="width: 100%"
						:src="data.host === 'mediaLibrary' ? data.video : data.src"
						:video-props="{
							videoAttrs: {
								controls: false,
								autoplay: 'autoplay',
								muted: 'muted',
								loop: 'loop',
							},
						}"
						:youtube-video-props="{
							iframeAttrs: {
								allow: 'autoplay; encrypted-media',
								allowfullscreen: 'allowfullscreen',
							},
							urlOptions: {
								controls: 0,
								showinfo: 0,
								rel: 0,
								autoplay: 1,
								mute: 1,
								loop: 1,
								playlist: data.video.data.videoId,
							},
						}"
						:vimeo-video-props="{
							iframeAttrs: {
								allow: 'autoplay; encrypted-media',
								allowfullscreen: 'allowfullscreen',
							},
							urlOptions: {
								background: 1,
								muted: 1,
								autoplay: 1,
							},
						}"
					/>

					<div class="overlay-content">
						<HtmlOrSlot :text="data.title" :class="{ 'title-active': isIntersecting }">
							<h3 class="font-2 font-sm-5 font-md-7 font-weight-bold white--text">
								{{ data.title }}
							</h3>
						</HtmlOrSlot>
						<HtmlOrSlot :text="data.subtitle" :class="{ 'subtitle-active': isIntersecting }">
							<h4 class="font-1 font-sm-3 font-md-5 font-weight-medium white--text">
								{{ data.subtitle }}
							</h4>
						</HtmlOrSlot>
						<v-btn
							class="cta font-weight-bold mt-5"
							:class="{ 'btn-active': isIntersecting, 'subtitle-active': isIntersecting }"
							:to="data.link"
							:small="$b.m"
						>
							<div v-html="data.cta"></div>
						</v-btn>
					</div>
				</div>
			</div>
		</RatioBox>
	</Container>
</template>

<style scoped>
.background-overlay {
	position: absolute;
	z-index: 1;
	width: 100%;
	height: 100%;
}

.video-container {
	position: relative;
	width: 100%;
	height: 100%;
	overflow: hidden;
}

#video-background {
	position: absolute;
	width: 100vw;
	height: 100vw;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
}

.overlay-content {
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	text-align: center;
	z-index: 2;
}

.title-active {
	animation: title 2s ease forwards;
}

.subtitle-active {
	animation: subtitle 2s ease forwards;
}

.btn-active {
	animation: btn 2s ease forwards;
}

@keyframes title {
	0% {
		transform: translateY(30px);
		opacity: 0;
	}
	40% {
		transform: translateY(30px);
		opacity: 0;
	}
	100% {
		transform: translateY(0);
		opacity: 1;
	}
}
@keyframes subtitle {
	0% {
		transform: translateY(30px);
		opacity: 0;
	}
	50% {
		transform: translateY(30px);
		opacity: 0;
	}
	100% {
		transform: translateY(0);
		opacity: 1;
	}
}
@keyframes btn {
	0% {
		transform: translateY(30px);
		opacity: 0;
	}
	60% {
		transform: translateY(30px);
		opacity: 0;
	}
	100% {
		transform: translateY(0);
		opacity: 1;
	}
}
</style>

